import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { config } from "@/lib/config";
import { queryClient, router } from "./router";
import "./styles/index.css";

async function boot() {
  if (config.mock) {
    const { startMocking } = await import("./mocks/browser");
    await startMocking();
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
